import { render, staticRenderFns } from "./AssetsModal.vue?vue&type=template&id=9c22fa20"
import script from "./AssetsModal.vue?vue&type=script&lang=js"
export * from "./AssetsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports